export default "__VITE_ASSET__bdc02141__"